export default __webpack_public_path__ + "static/media/bell_2.3b19e9c3.svg";